var sourceUrl;
var documentWidth = $(document).width();

$(window).resize(function () {
  documentWidth = $(document).width();
});

function GetLanguage() {
  return window.location.pathname.split("/")[1];
}

// sort arrayObject
function sortArrayObject(key, order = "asc") {
  return function (a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    var varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
    var varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

    var comparison = 0;

    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order == "desc" ? comparison * -1 : comparison;
  };
}

// select destination //////////////////////////////////

var travelServiceLocationList;

$(function () {
  if (window.travelServiceDestinations && window.travelServiceDestinations.length) {
    travelServiceLocationList = window.travelServiceDestinations;
  } else {
    $.get("/travelservice-api/searchtitle/", function (data, status) {
      if (data.model && data.model.length) {
        travelServiceLocationList = data.model;
      }
    });
  }

  $(".js-search-travel-service").click(function (event) {
    var localStorageKey = `${window.prefixSearchHistory}-${
      $(".js-search-holder-landing").attr("id") ||
      $(this).closest(".js-tab-nav").find(".js-tab-content>div.active").attr("id")
    }`;
    var searchHistoryItem = {
      value: {},
      baseUrl: "",
      expire: "",
    };
    event.preventDefault();

    var baseUrl = "/tourismservicessearch/";
    var valid = true;

    $(".js-travel-service-booking").find(".js-error-message").remove();
    $(".js-travel-service-booking-input").removeClass("error");

    let travelServiceLocation = $(".js-travel-service-location").data();
    if (travelServiceLocation["value"]) {
      searchHistoryItem.value = {
        countrySlug: travelServiceLocation["countrySlug"],
        citySlug: travelServiceLocation["citySlug"],
        value: travelServiceLocation["value"],
        title: $(".js-travel-service-location").attr("placeholder"),
      };
      baseUrl +=
        travelServiceLocation["countrySlug"] +
        "/" +
        travelServiceLocation["citySlug"] +
        "/?d=" +
        travelServiceLocation["value"];
    } else {
      $(".js-travel-service-location").closest(".js-travel-service-booking-input").addClass("error");
      valid = false;
    }

    if (!valid) {
      $(".js-travel-service-booking").append(
        "<span class='form-validation js-error-message'>لطفا مقصد مورد نظرتان را انتخاب کنید</span>"
      );
      return false;
    } else {
      searchHistoryItem = {
        ...searchHistoryItem,
        baseUrl: baseUrl,
        expire: moment().add(1, "months").format("YYYY-MM-DD"),
      };

      window.updateLocalStorage(localStorageKey, searchHistoryItem);
      window.location.assign(baseUrl);
    }
  });

  // init location autoComplete
  $(".js-travel-service-location")
    .autocomplete({
      minLength: 0,
      delay: 400,
      source: function (request, response) {
        if (request.term === "") {
          var items = travelServiceLocationList && travelServiceLocationList.length ? travelServiceLocationList : [];
          response(items);
        } else {
          var url = getResult($(".js-travel-service-location"));
          $.getJSON(url).done(function (serverResponse) {
            response(serverResponse.model);
          });
        }
      },
      appendTo: $(".js-travel-service-location").next(),
      search: function () {
        $(this).closest(".js-travel-service-booking-input").addClass("is-open");

        if (window.innerWidth < 993) {
          $("html").addClass("no-scroll");
        }
      },
      select: function (event, ui) {
        $(this).attr("data-value", ui.item.id);
        $(this).attr("data-country-slug", ui.item.countrySlug);
        $(this).attr("data-city-slug", ui.item.slug);
        $(this).val();

        $(this).data({
          value: ui.item.id,
          "country-slug": ui.item.countrySlug,
          "city-slug": ui.item.slug,
        });

        $(this).attr("placeholder", ui.item.title);
        $(this).closest(".js-travel-service-booking-input").removeClass("is-open");

        setTimeout(() => {
          $(this).trigger("blur");
        }, 10);
      },
      open: function () {
        $(".ui-autocomplete").off("menufocus hover mouseover mouseenter");
        //off autocomplete in chrome
        let chromeAgent = navigator.userAgent.indexOf("Chrome") != -1;
        if (chromeAgent) {
          $(this).attr("autocomplete", "off");
        }
        var inputObj = $(this);
        inputObj
          .next(".travel-service-autocomplete-list")
          .children("ul")
          .css({
            top: "+=" + 12,
          });
      },
      close: function (e, ui) {
        $("html").removeClass("no-scroll");
      },
    })
    .bind("focus", function () {
      $(this).keydown();
    })
    .bind("blur", function () {
      $(this).val($(this).attr("placeholder"));
    })

    .autocomplete("instance")._renderItem = function (ul, item) {
    var li = "";
    li +=
      '<li><span class="item-wrapper">' +
      '<i class="icon-map"></i><span class="city-title">' +
      item.title +
      "</span></li>";
    return $(li).appendTo(ul);
  };

  // close location
  $(".js-travel-service-booking").delegate(".js-close-location-list", "click", function () {
    $(".js-travel-service-location").autocomplete("close");
    $(this).closest(".js-travel-service-booking-input").removeClass("is-open");
    $("html").removeClass("no-scroll");
  });

  // update auto complete after type
  function getResult(input) {
    var dataUrl = "/travelservice-api/searchtitle/";

    if (input.val()) {
      dataUrl += input.val() + "/";
    }
    return dataUrl;
  }
});

$(".js-travel-service-location").click(() => {
  $(".js-travel-service-location").trigger("focus");
});
